import {
  ADVANCED_SEARCH_FIELD,
  ADVANCED_SEARCH_QUALIFIER,
  FIELDS_TO_SEARCH_OPTION_MAP,
  SEARCH_OPERATOR_MAP,
} from '../constants';

export interface FieldQualifierValue {
  field: ADVANCED_SEARCH_FIELD;
  qualifier: ADVANCED_SEARCH_QUALIFIER;
  value: string;
}

const getValueWithAsterisks = ({ qualifier, value }: FieldQualifierValue) =>
  `${qualifier !== ADVANCED_SEARCH_QUALIFIER.startsWith ? '*' : ''}${value}*`;

const getQueryWithQualifier = ({
  field,
  qualifier,
  value,
  isSpaceSeparated = false,
  customOperator = '',
}: {
  isSpaceSeparated?: boolean;
  customOperator?: string;
} & FieldQualifierValue) => {
  const mappedOperator = customOperator || SEARCH_OPERATOR_MAP[qualifier];
  const formattedOperator = isSpaceSeparated
    ? ` ${mappedOperator} `
    : mappedOperator;

  return `${FIELDS_TO_SEARCH_OPTION_MAP[field]}${formattedOperator}"${value}"`;
};

export const getCqlFieldQualifierValue = ({
  field,
  qualifier,
  value,
}: FieldQualifierValue): string => {
  if (qualifier === ADVANCED_SEARCH_QUALIFIER.exactPhrase) {
    return getQueryWithQualifier({
      field,
      qualifier,
      value,
    });
  }

  const formattedValue =
    qualifier === ADVANCED_SEARCH_QUALIFIER.startsWith
      ? getValueWithAsterisks({ qualifier, value, field })
      : value;

  return getQueryWithQualifier({
    field,
    qualifier,
    value: formattedValue,
    isSpaceSeparated: true,
  });
};
